import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Settings from 'app/components/Settings'
import { classNames } from 'app/functions'
import { useCurrency } from 'app/hooks/Tokens'
import React, { useMemo, useState } from 'react'
import {
  Box,
  Image,
  Heading
} from '@chakra-ui/react';

import PoolAddLiquidity from './PoolAddLiquidity'
import PoolRemoveLiquidity from './PoolRemoveLiquidity'

// @ts-ignore TYPE NEEDS FIXING
const ManageSwapPair = ({ farm }) => {
  const { i18n } = useLingui()
  const [toggle, setToggle] = useState(true)

  const token0 = useCurrency(farm.pair.token0.id)
  const token1 = useCurrency(farm.pair.token1.id)

  const header = useMemo(
    () => (
      <>
        <Box className='liq_swich_txt'>
          <Box className='add_liqy_txt'>
            <Heading as="h5">{toggle ? i18n._(t`Add liquidity`) : i18n._(t`Remove liquidity`)}</Heading>
          </Box>
          <Box className='swich_setting'>
            <Box className='nw_swich_v2 nw_swich_v2'>
              <Box className='swtch_main swtch_main_liq_p_up'>
                <Box className='switch_box switch_boxv2'>
                  <input type="checkbox" id='switchOne' checked={toggle} onChange={() => setToggle(!toggle)} />
                  <label htmlFor="switchOne">
                    <span>
                      <Image src='/img/mns_icon.svg' className='mns_icon' alt='' />
                      <Image src='/img/plus_icon_p_up.svg' className='pls_icon' alt='' />
                    </span>
                  </label>
                </Box>
              </Box>
            </Box>
            <Settings className="w-[unset] h-[unset]" />
          </Box>
        </Box>
      </>
    ),
    [i18n, toggle]
  )

  return (
    <>
    <Box className='last_teb_panal'>
      {header}
      <div className={classNames(toggle ? '' : 'hidden')}>
        <PoolAddLiquidity currencyA={token0} currencyB={token1} header={header} />
      </div>
      <div className={classNames(!toggle ? '' : 'hidden')}>
        <PoolRemoveLiquidity currencyA={token0} currencyB={token1} header={header} />
      </div>
    </Box>
    </>
  )
}

export default ManageSwapPair
